
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Montauban dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Montauban certifiée Google Partner, aide les entreprises montalbanaises à renforcer leur présence en ligne et à conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Montauban dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Montauban certifiée Google Partner, aide les entreprises montalbanaises à renforcer leur présence en ligne et à conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
